import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

import Barcode from '../../../../base/Barcode';
import ModalToBody from '../../../../base/ModalToBody';

class BarcodeButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };

    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
  }

  static propTypes = {
    barcode: PropTypes.string,
  };

  _closeModal() {
    this.setState({ showModal: false });
  }

  _openModal() {
    this.setState({ showModal: true });
  }

  render() {
    const { showModal } = this.state;
    const { barcode } = this.props;

    return (
      <span>
        <button
          type="button"
          className="btn btn-outline-info m-btn btn-sm  m-btn--icon m--margin-left-5"
          onClick={this._openModal}
        >
          <span>
            <i className="la la-eye" />
            <span>
              <Trans>Barcode</Trans>
            </span>
          </span>
        </button>

        <ModalToBody render={showModal}>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1039',
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Barcode
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body flex flex-col justify-center items-center">
                  <Barcode barcode={barcode} />
                </div>
              </div>
            </div>
          </div>

          <div
            className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1038',
            }}
            onClick={this._closeModal}
          />
        </ModalToBody>
      </span>
    );
  }
}

export default BarcodeButton;
